module.exports = __webpack_public_path__ + "media/errors/unknown-error-2181795a.png";